class MobileNav {
  stateClasses = {
    expanded: 'mobile-nav__cluster--expanded',
  };
  constructor($el) {
    console.log('Mobilenav');
    this.$el = $el;
    this.$clusters = $el.find('[data-mobile-nav="cluster"]');
    this.$trigger = $el.find('[data-mobile-nav="trigger"]');
    this.$content = $el.find('[data-mobile-nav="content"]');

    this.init();
  }

  init = () => {
    this.$trigger.on('click', this.toggle);
  }

  toggle = (e) => {
    // get parent cluster
    const $trigger = $(e.currentTarget);
    const $cluster = $trigger.closest('[data-mobile-nav="cluster"]');

    const $otherClusters = this.$clusters.not($cluster);

    // collapse other clusters
    $otherClusters.each((i, el) => {

      const $el = $(el);
      const expanded = $el.hasClass(this.stateClasses.expanded);

      if (expanded) {
        this.collapse($el);
      }
    });

    // check if cluster is expanded
    const expanded = $cluster.hasClass(this.stateClasses.expanded);

    // if expanded, collapse
    if (expanded) {
      this.collapse($cluster);
    } else {
      this.expand($cluster);
    }
  }

  expand = ($cluster) => {
    const $content = $cluster.find('[data-mobile-nav="content"]');

    // get content height to scrollHeight
    const height = $content.prop('scrollHeight');
    
    // set max-height to height
    $content.css('max-height', height);

    // listen to transition end
    $content.one('transitionend', this.transitionEndHandler);

    $cluster.addClass(this.stateClasses.expanded);
  }

  collapse = ($cluster) => {
    const $content = $cluster.find('[data-mobile-nav="content"]');

    // set max-height to current height and on next frame, set max-height to 0
    const height = $content.outerHeight();
    $content.css('max-height', height);

    // on next frame
    requestAnimationFrame(() => {
      // set max-height to 0
      $content.css('max-height', 0);
    });

    $cluster.removeClass(this.stateClasses.expanded);
  }

  collapseAll = () => {
    this.$clusters.each((i, el) => {
      const $el = $(el);
      const expanded = $el.hasClass(this.stateClasses.expanded);

      if (expanded) {
        this.collapse($el);
      }
    });
  }

  transitionEndHandler = (e) => {
    const $content = $(e.currentTarget);
    
    // set max-height to none
    $content.css('max-height', 'none');
  }




}

export default MobileNav;